import * as Yup from "yup";
import valid from "card-validator";
import { REGEX } from "../../../utils/constants";
import { validation } from "../../../utils/validation";
/**
 * @description declaration form schema for client validations
 */
export const PaymtSchema = Yup.object().shape({
    card: Yup.string()
        .required("This field is required")
        .test(
            "test-number",
            "Credit Card number is invalid",
            value => valid.number(value).isValid),
    exp: Yup.string()
        .test(
            'test-credit-card-expiration-date',
            'Invalid Expiration Date has past',
            expirationDate => validation.expirationDate(expirationDate)
        )
        .test(
            'test-credit-card-expiration-date',
            'Invalid Expiration Month',
            expirationDate => validation.expirationMonth(expirationDate)
        )
        .typeError('Not a valid expiration date. Example: MM/YY')
        .max(5, 'Not a valid expiration date. Example: MM/YY')
        .matches(/([0-9]{2})\/([0-9]{2})/, 'Not a valid expiration date. Example: MM/YY')
        .required('Expiration date is required'),
    
    cvv: Yup.string()
        .required("This field is required"),
    holder: Yup.string().matches(REGEX.NAME,
        'This field only accepts alphabets!')
        .required("This field is required"),
});



/**
 * @description params intilaization 
 */

export const PaymtInit = {
    card: '',
    holder: '',
    exp: '',
    cvv: ''
}